<template>
  <div class="app-container" id="courseFileList">
    <div class="mycontainer">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
      >
        <el-form-item label="课题属性" prop="courseGroup">
          <el-select
            ref="courseGroup"
            v-model="listQuery.courseGroup"
            placeholder="请选择课题属性"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in groupOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="所属阶段" prop="step">
          <el-select
            ref="step"
            v-model="listQuery.step"
            placeholder="请选择所属阶段"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in stepOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="是否启用" prop="isUse">
          <el-select
            ref="isUse"
            v-model="listQuery.isUse"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in isUseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间" prop="createTime">
          <el-date-picker
            v-model="value1"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addDialog = true"
            style="margin-left: 15px"
            >新增</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="this.listLoading"
        :data="this.list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="操作"
          min-width="120"
          align="center"
          class-name="small-padding fixed-width"
        >
          <!-- <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>

            <el-button size="mini" type="text" @click="handleDeleteTime(scope.row)">删除</el-button >
          </template>-->
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              plain
              @click="handleEdit(scope.row)"
              style="margin-left: 5px"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              plain
              @click="handleToPropList(scope.row)"
              style="margin-left: 5px"
              >属性列表</el-button
            >
            <el-popconfirm
              v-if="scope.row.courseCount == 0 && scope.row.isUse == '否'"
              title="确定删除吗？"
              @confirm="deleteMeta(scope.row.metaId)"
            >
              <el-button
                slot="reference"
                type="text"
                size="mini"
                style="margin-left: 5px"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column
          label="课题属性"
          align="left"
          prop="courseGroup"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目类型"
          align="left"
          prop="courseProject"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题阶段名称"
          align="left"
          prop="step"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="阶段表单名"
          align="left"
          prop="fromTitle"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="是否启用"
          align="left"
          prop="isUse"
          min-width="70px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="创建人"
          align="left"
          prop="createBy"
          min-width="70px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          align="left"
          prop="createTime"
          min-width="70px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="this.total > 0"
        :total="this.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增表单"
      :visible.sync="addDialog"
      width="800px"
      v-if="addDialog"
      id="mx-dialog"
    >
      <AddMeta
        :mxParams="mxParams"
        ref="addMeta"
        @getParentForm="getList"
      ></AddMeta>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addMetaForm">确定</el-button>
        <el-button @click="addDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑表单"
      :visible.sync="editDialog"
      width="800px"
      v-if="editDialog"
      id="mx-dialog"
    >
      <EditMeta
        :mxParams="mxParams"
        ref="editMeta"
        @getParentForm="getList"
      ></EditMeta>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editMetaForm">确定</el-button>
        <el-button @click="editDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import { getDictData } from "@/api/task.js";
import { listMeta, deleteMeta } from "@/api/meta.js";
import AddMeta from "./addMeta.vue";
import EditMeta from "./editMeta.vue";
import { formatMomentDate } from "@/utils/utils";

export default {
  // 列表分页
  components: {
    Pagination,
    AddMeta,
    EditMeta,
  },
  data() {
    return {
      type: "0",
      height: 100,
      total: 0,
      listLoading: true,
      list: [],

      listQuery: {
        courseGroup: "",
        step: "",
        isUse: "",
        qsrq: "",
        jsrq: "",
        page: 1,
        pageSize: 50,
      },
      groupOptions: [],
      stepOptions: [],
      projectOptions: [],
      isUseOptions: [
        { value: "1", label: "是" },
        { value: "0", label: "否" },
      ],

      addDialog: false,
      editDialog: false,
      value1: "",
    };
  },
  computed: {
    ...mapGetters(["course"]),
  },
  created() {
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.groupOptions = res.data;
      }
    });

    //项目类型
    getDictData("pmp_course_project", 1).then((res) => {
      if (res.code === 0) {
        this.projectOptions = res.data;
      }
    });

    //所属阶段
    getDictData("pmp_course_step", 1).then((res) => {
      if (res.code === 0) {
        // this.stepOptions = res.data;
        let temp = res.data.filter(
          (ele) =>
            ele.dictLabel.indexOf("申请") != -1 ||
            ele.dictLabel.indexOf("延迟结项") != -1
        );
        for (let i in temp) {
          if (temp[i].dictLabel == "中期检查申请") {
            temp[i].dictValue = "4";
          }
        }
        this.stepOptions = temp;
      }
    });
    this.getList();
  },
  methods: {
    getList() {
      this.addDialog = false;
      this.editDialog = false;
      if (this.value1) {
        this.listQuery.qsrq = formatMomentDate(
          new Date(this.value1[0]),
          "yyyyMMdd"
        );
        this.listQuery.jsrq = formatMomentDate(
          new Date(this.value1[1]),
          "yyyyMMdd"
        );
      } else {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
      }
      listMeta(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 165;
          for (let i in this.list) {
            if (this.list[i].step == "中期检查评审") {
              this.list[i].step = "中期检查申请";
            }
          }
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleEdit(row) {
      this.editDialog = true;
      this.mxParams = row;
    },
    handleChangeTime(value) {
      if (!value) {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
        return;
      }
      this.listQuery.qsrq = formatMomentDate(value[0]);
      this.listQuery.jsrq = formatMomentDate(value[1]);
    },

    addMetaForm() {
      this.$refs.addMeta.saveForm();
    },
    editMetaForm() {
      this.$refs.editMeta.saveForm();
    },

    deleteMeta(metaId) {
      const pa = { metaId: metaId };
      deleteMeta(pa).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleToPropList(row) {
      this.$router.push({
        name: "propList",
        params: {
          metaId: row.metaId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
</style>
